import React, { useEffect, useState, useMemo, useRef } from "react";
import HeaderCompo from "../../component/Header";
import {
  Button,
  Checkbox,
  DatePicker,
  Input,
  message,
  Table,
  Tooltip,
  Card,
  Row,
  Col,
  Spin,
} from "antd";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip as ChartTooltip,
  Legend,
  ResponsiveContainer,
  BarChart,
  Bar,
} from "recharts";
import {
  ArrowUpOutlined,
  ArrowDownOutlined,
  CaretDownOutlined,
  DownloadOutlined,
  FilterOutlined,
  InfoCircleOutlined,
  SearchOutlined,
} from "@ant-design/icons";
import dayjs from "dayjs";
import { axiosInstance } from "../../utils/axiosInterceptor";
import * as XLSX from "xlsx";
import { render } from "@testing-library/react";
import "../smsWorkflow/smsWorkflow.css";
import moment from "moment";
const Trends = ({ embedded = false }) => {
  const [data, setData] = useState([]);
  const [tableData, setTableData] = useState([]);
  const [originalData, setOriginalData] = useState([]);
  const [changedMap, setChangedMap] = useState({});
  const [isCheckBoxChange, setIsCheckBoxChange] = useState(false);
  const [searchText, setSearchText] = useState("");

  const [isLoading, setLoading] = useState(false);
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [searchAccount,setSearchAccount] = useState("")
  // const [pagination, setPagination] = useState(10);
  const [loadingCheck, setLoadingCheck] = useState(false);
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
    total: 0,
  });
  const getCurrentMonth = () => {
  return new Date().toISOString().slice(0, 7);
};
  const [monthlyTrends, setMonthlyTrends] = useState([]);
  const [searchTextMonth, setSearchMonth] = useState("");
  const [isLoadingMonth, setIsLoadingMonth] = useState(false);
  const [fromDateMonth, setFromDateMonth] = useState(getCurrentMonth());
  const [toDateMonth, setToDateMonth] = useState(getCurrentMonth());
  const [paginationMonth, setPaginationMonth] = useState(10);
  const [allGrphsData, setAllGraphsData] = useState([]);
  const [isLoadingGrpah, setIsLoadingGraph] = useState(false);
  const [dailyTrendExport,setIsDailyTrendExporting] = useState(false)
  const [monthlyTrendExport,setIsMonthlyTrendExporting] = useState(false)
  const isFirstRender = useRef(true);

  const getDailyTrendsData = async (fromDate, toDate, page = 1, limit = 10) => {
    let url = `/api/management/daily-negative-trends?page=${page}&limit=${limit}&search=${searchText}`;
    if (fromDate && toDate) {
      url += `&fromDate=${fromDate}&toDate=${toDate}`;
    }

    setLoading(true);
    try {
      const response = await axiosInstance.get(url);
      const normalized = response?.data?.data;
      const paginationData = response?.data?.pagination;
      setData(normalized);
      setTableData(normalized);
      setOriginalData(normalized);
      setChangedMap({});
      setIsCheckBoxChange(false);
      setPagination({
        current: paginationData?.page || page,
        pageSize: paginationData?.limit || limit,
        total: paginationData?.totalCount || 0,
      });
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };
  const getMothlyTrendsData = async (fromDateMonth, toDateMonth) => {
    if(!fromDateMonth || !toDateMonth){
      // message.error("")
      return;
    }
    let url = "/api/management/monthly-negative-trends";
    if (fromDateMonth) {
      const fromMonth = formatMonthForApi(fromDateMonth);
      const toMonth = formatMonthForApi(toDateMonth);
      url += `?fromMonth=${fromMonth}&toMonth=${toMonth}`;
    }
    setIsLoadingMonth(true);
    try {
      const response = await axiosInstance.get(url);
      console.log(response, "Responseeee");
      setMonthlyTrends(response?.data?.data);
    } catch (err) {
      console.error(err);
    } finally {
      setIsLoadingMonth(false);
    }
  };

  useEffect(() => {
    getDailyTrendsData();
    getAllGraphsData();
  }, []);

 useEffect(() => {
     if (isFirstRender.current) {
       isFirstRender.current = false;
       return;
     }
     if (searchAccount?.length === 0) {
       getAllGraphsData();
     }
   }, [searchAccount]);

  useEffect(()=>{
    getMothlyTrendsData(fromDateMonth,toDateMonth);
  },[fromDateMonth,toDateMonth])

  useEffect(() => {
  const timer = setTimeout(() => {
    getDailyTrendsData();
  }, 400);

  return () => clearTimeout(timer);
}, [searchText]);

  const getAllGraphsData = async (val) => {
    setIsLoadingGraph(true);
    try {
      let response;
      if (val) {
      response = await axiosInstance.get(
        "api/management/monthly-trends",
        {
          params: {
            accountLevel: "account",
            accounts: val,
          },
        }
      );
    } else {
      response = await axiosInstance.get(
        "api/management/monthly-trends"
      );
    }
      // const response = await axiosInstance.get("api/management/monthly-trends");
      if (response?.data) {
        setAllGraphsData(response?.data?.data);
      }
    } catch (error) {
      console.log(error, "Errro");
    } finally {
      setIsLoadingGraph(false);
    }
  };

  const handleCheckboxChange = (id, key, checked) => {
    const newValue = checked ? 1 : 0;

    setTableData((prev) =>
      prev.map((item) =>
        item.id === id ? { ...item, [key]: newValue } : item,
      ),
    );

    setChangedMap((prev) => {
      const original = originalData.find((i) => i.id === id);

      if (original[key] === newValue) {
        const { [id]: _, ...rest } = prev;
        return rest;
      }

      return {
        ...prev,
        [id]: {
          ...(prev[id] || {
            id,
            email_enabled: original.email_enabled,
            sms_enabled: original.sms_enabled,
          }),
          [key]: newValue,
        },
      };
    });

    setIsCheckBoxChange(true);
  };

  const handleSave = async () => {
    const payload = {
      updates: Object.values(changedMap),
    };
    if (payload.updates?.length === 0) {
      message.info("There are no modified records to update.");
      setIsCheckBoxChange(false);
      return;
    }
    setLoadingCheck(true);
    try {
      await axiosInstance.post("/api/v2/powerbi/dailyTrends/enable", payload);

      message.success("Settings updated successfully");
      setChangedMap({});
      getDailyTrendsData();
      setIsCheckBoxChange(false);
    } catch (error) {
      message.error("Something went wrong");
    } finally {
      setLoadingCheck(false);
    }
  };

  const formatMonthForApi = (date) => {
    if (!date) return "";

    const d = new Date(date);
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, "0");

    return `${year}-${month}`;
  };

  const handleExport = async() => {
    let url = `/api/management/daily-negative-trends?export=${true}`;
    if (fromDate && toDate) {
      url += `&fromDate=${fromDate}&toDate=${toDate}`;
    }
    setIsDailyTrendExporting(true);
    try {
      const response = await axiosInstance.get(url);
      const data = response?.data?.data;
      const headers = [
      "Account Number",
      "Account Name",
      // "Loc Id",
      // "Email",
      // "phone",
      "Date",
      "GCR %",
      "SGCR %",
      "Previous GCR %",
      // "Current GCR %",
      // "GCR Diff",
      "Previous SGCR %",
      // "Current SGCR %",
      // "SGCR Diff",
      "Delta GCR %",
      "Delta SGCR %",
      // "Trend Type",
      // "Current GPR %",
      // "GPR Diff",
      // "Trend",
      // "Trend Type",
      // "Streak Days",
      // "Email Enabled",
      // "SMS Enabled",
    ];

    const rows = data?.map((item) => [
      item.accountId,
      item.accountName,
      // item?.LocID,
      // item.email,
      // item?.phone,
      item.perfDate,
      item.gcr,
      item.sgcr,
      item?.previousGcr,
      item?.previousSgcr,
      item.deltaGcr,
      item.deltaSgcr,
      // item?.trendType,
      // item.trend,
      // item.trendType,
      // item.streakDays,
      // item?.email_enabled,
      // item?.sms_enabled,
    ]);

    const worksheet = XLSX.utils.aoa_to_sheet([headers, ...rows]);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Daily Trends");
    XLSX.writeFile(workbook, "DailyTrends.xlsx");
    } catch (err) {
      console.error(err);
    } finally {
      setIsDailyTrendExporting(false);
    }
  };
  const handleExportMonth = () => {
    const headers = [
      "Month",
      "Loc Id",
      "Account Number",
      "Account Name",
      "Email",
      "phone",
      "GCR",
      "SGCR",
      "GPR",
      "Previous GCR %",
      "Previous SGCR %",
      "Previous GPR %",
      "Delta GCR %",
      "Delta SGCR %",
      "Delta GPR %",
      // "Trend",
      // "Trend Type",
      // "Streak Days",
      // "Email Enabled",
      // "SMS Enabled",
    ];

    const rows = monthlyTrends?.map((item) => [
      item.month,
      item?.LocID,
      item.accountId,
      item.accountName,
      item.email,
      item?.phone,
      item.gcr,
      item.sgcr,
      item?.gpr,
      item?.previousGcr,
      item?.previousSgcr,
      item?.previousGpr,
      item.deltaGcr,
      item.deltaSgcr,
      item?.deltaGpr,
      // item.trend,
      // item.trendType,
      // item.streakDays,
      // item?.email_enabled,
      // item?.sms_enabled,
    ]);

    const worksheet = XLSX.utils.aoa_to_sheet([headers, ...rows]);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "monthly Trends");
    XLSX.writeFile(workbook, "MonthlyTrends.xlsx");
  };

  // const columns = [
  //   {
  //     title: "Date",
  //     dataIndex: "perfDate",
  //     sorter: false,
  //     // sorter: (a, b) => parseFloat(a.LocID || 0) - parseFloat(b.LocID || 0),
  //     render: (text, record) => (
  //       <span>{moment(text).format("MM-DD-YYYY")}</span>
  //     ),
  //   },
  //   {
  //     title: "Account Number",
  //     dataIndex: "accountId",
  //     align: "right",
  //     sorter: false,
  //     sorter: (a, b) => String(a.accountId).localeCompare(String(b.accountId)),
  //     filteredValue: [searchText],
  //     onFilter: (value, record) => {
  //       return (
  //         String(record.accountName)
  //           .toLowerCase()
  //           .includes(value.toLowerCase()) ||
  //         String(record.email).toLowerCase().includes(value.toLowerCase()) ||
  //         String(record.accountId)
  //           .toLowerCase()
  //           .includes(value.toLowerCase()) ||
  //         String(record.phone).toLowerCase().includes(value.toLowerCase())
  //       );
  //     },
  //   },
  //   {
  //     title: "Account Name",
  //     dataIndex: "accountName",
  //     sorter: false,
  //     sorter: (a, b) =>
  //       String(a.accountName).localeCompare(String(b.accountName)),
  //     render: (text, record) => (
  //       <span
  //         className="cursor-pointer hover:underline hover:text-blue-800 transition"
  //         onClick={() => {
  //           const formattedAccountId = record.accountId
  //             ?.toString()
  //             .startsWith("0")
  //             ? record.accountId.toString().replace(/^0+/, "")
  //             : record.accountId;

  //           const params = new URLSearchParams({
  //             accountId: Number(formattedAccountId),
  //             accountName: record.accountName,
  //           }).toString();

  //           window.open(`/react-dashboard?${params}`, "_blank");
  //         }}
  //       >
  //         {text}
  //       </span>
  //     ),
  //   },

  //   {
  //     title: "GCR %",
  //     dataIndex: "gcr",
  //     align: "right",
  //     sorter: false,
  //     // sorter: (a, b) => parseFloat(a.gpr || 0) - parseFloat(b.gpr || 0),
  //     render: (val) =>
  //       val === undefined || val === "" || val === "null"
  //         ? "-"
  //         : `${val?.toFixed(2)}%`,
  //   },
  //   {
  //     title: "SGCR %",
  //     dataIndex: "sgcr",
  //     align: "right",
  //     sorter: false,
  //     render: (val) =>
  //       val === undefined || val === "" || val === "null"
  //         ? "-"
  //         : `${val?.toFixed(2)}%`,
  //   },
  //   // {
  //   //   title: "GPR %",
  //   //   dataIndex: "gpr",
  //   //   align: "right",
  //   //   sorter: true,
  //   //   render: (val) =>
  //   //     val === undefined || val === "" || val === "null" ? "-" : `${val?.toFixed(2)}%`,
  //   // },
  //   {
  //     title: "previous GCR %",
  //     dataIndex: "previousGcr",
  //     align: "right",
  //     sorter: false,
  //     // sorter: (a, b) => parseFloat(a.gpr || 0) - parseFloat(b.gpr || 0),
  //     render: (val) =>
  //       val === undefined || val === "" || val === "null"
  //         ? "-"
  //         : `${val?.toFixed(2)}%`,
  //   },
  //   {
  //     title: "previous SGCR %",
  //     dataIndex: "previousSgcr",
  //     align: "right",
  //     sorter: false,
  //     // sorter: (a, b) => parseFloat(a.gpr || 0) - parseFloat(b.gpr || 0),
  //     render: (val) =>
  //       val === undefined || val === "" || val === "null"
  //         ? "-"
  //         : `${val?.toFixed(2)}%`,
  //   },
  //   // {
  //   //   title: "Previous GPR %",
  //   //   dataIndex: "previousGpr",
  //   //   align: "right",
  //   //   sorter: true,
  //   //   // sorter: (a, b) => parseFloat(a.gpr || 0) - parseFloat(b.gpr || 0),
  //   //   render: (val) =>
  //   //     val === undefined || val === "" || val === "null" ? "-" : `${val?.toFixed(2)}%`,
  //   // },
  //   {
  //     title: "Delta GCR %",
  //     dataIndex: "deltaGcr",
  //     align: "right",
  //     sorter: false,
  //     // sorter: (a, b) => parseFloat(a.gpr || 0) - parseFloat(b.gpr || 0),
  //     render: (val) =>
  //       val === undefined || val === "" || val === "null"
  //         ? "-"
  //         : `${val?.toFixed(2)}%`,
  //   },
  //   {
  //     title: "Delta SGCR %",
  //     dataIndex: "deltaSgcr",
  //     align: "right",
  //     sorter: false,
  //     // sorter: (a, b) => parseFloat(a.gpr || 0) - parseFloat(b.gpr || 0),
  //     render: (val) =>
  //       val === undefined || val === "" || val === "null"
  //         ? "-"
  //         : `${val?.toFixed(2)}%`,
  //   },
  //   // {
  //   //   title: "Delta GPR %",
  //   //   dataIndex: "deltaGpr",
  //   //   align: "right",
  //   //   sorter: true,
  //   //   // sorter: (a, b) => parseFloat(a.gpr || 0) - parseFloat(b.gpr || 0),
  //   //   render: (val) =>
  //   //     val === undefined || val === "" || val === "null" ? "-" : `${val?.toFixed(2)}%`,
  //   // },
  //   {
  //     title: "Trend Type",
  //     dataIndex: "trendType",
  //     align: "right",
  //     sorter: false,
  //     // sorter: (a, b) => parseFloat(a.gpr || 0) - parseFloat(b.gpr || 0),
  //     render: (val) =>
  //       val === undefined || val === "" || val === "null" ? "-" : val,
  //   },
  // ];

  // const columnsMonth = [
  //   {
  //     title: "Month",
  //     dataIndex: "month",
  //     sorter: false,
  //     render: (month) => moment(month, "YYYY-MM").format("MM-YYYY"),
  //   },
  //   {
  //     title: "Loc ID",
  //     dataIndex: "LocID",
  //     align: "right",
  //     sorter: false,
  //     render: (text, record) => (
  //       <span className="transition">{text ?? "-"}</span>
  //     ),
  //   },
  //   {
  //     title: "Account Number",
  //     dataIndex: "accountId",
  //     align: "right",
  //     sorter: false,
  //     render: (text, record) => (
  //       <span className="transition">{text ?? "-"}</span>
  //     ),
  //   },
  //   {
  //     title: "Account Name",
  //     dataIndex: "accountName",
  //     sorter: false,
  //     filteredValue: [searchTextMonth],
  //     onFilter: (value, record) => {
  //       return (
  //         String(record.accountName)
  //           .toLowerCase()
  //           .includes(value.toLowerCase()) ||
  //         String(record.email).toLowerCase().includes(value.toLowerCase()) ||
  //         String(record.accountId)
  //           .toLowerCase()
  //           .includes(value.toLowerCase()) ||
  //         String(record.phone).toLowerCase().includes(value.toLowerCase())
  //       );
  //     },
  //     render: (text, record) => (
  //       <span className="transition">{text ?? "-"}</span>
  //     ),
  //   },
  //   {
  //     title: "Email",
  //     dataIndex: "email",
  //     align: "left",
  //     // sorter: true,
  //     // sorter: (a, b) => parseFloat(a.gpr || 0) - parseFloat(b.gpr || 0),
  //     render: (val) => val ?? "-",
  //   },
  //   {
  //     title: "Phone",
  //     dataIndex: "phone",
  //     align: "left",
  //     // sorter: center,
  //     // sorter: (a, b) => parseFloat(a.gpr || 0) - parseFloat(b.gpr || 0),
  //     render: (val) => val ?? "-",
  //   },
  //   {
  //     title: "GCR %",
  //     dataIndex: "gcr",
  //     align: "right",
  //     sorter: false,
  //     // sorter: (a, b) => parseFloat(a.gpr || 0) - parseFloat(b.gpr || 0),
  //     render: (val) =>
  //       val === undefined || val === "" || val === "null"
  //         ? "-"
  //         : `${val?.toFixed(2)}%`,
  //   },
  //   {
  //     title: "SGCR %",
  //     dataIndex: "sgcr",
  //     align: "right",
  //     sorter: false,
  //     render: (val) =>
  //       val === undefined || val === "" || val === "null"
  //         ? "-"
  //         : `${val?.toFixed(2)}%`,
  //   },
  //   {
  //     title: "GPR %",
  //     dataIndex: "gpr",
  //     align: "right",
  //     sorter: false,
  //     render: (val) =>
  //       val === undefined || val === "" || val === "null"
  //         ? "-"
  //         : `${val?.toFixed(2)}%`,
  //   },
  //   {
  //     title: "previous GCR %",
  //     dataIndex: "previousGcr",
  //     align: "right",
  //     sorter: false,
  //     // sorter: (a, b) => parseFloat(a.gpr || 0) - parseFloat(b.gpr || 0),
  //     render: (val) =>
  //       val === undefined || val === "" || val === "null"
  //         ? "-"
  //         : `${val?.toFixed(2)}%`,
  //   },
  //   {
  //     title: "previous SGCR %",
  //     dataIndex: "previousSgcr",
  //     align: "right",
  //     sorter: false,
  //     // sorter: (a, b) => parseFloat(a.gpr || 0) - parseFloat(b.gpr || 0),
  //     render: (val) =>
  //       val === undefined || val === "" || val === "null"
  //         ? "-"
  //         : `${val?.toFixed(2)}%`,
  //   },
  //   {
  //     title: "Previous GPR %",
  //     dataIndex: "previousGpr",
  //     align: "right",
  //     sorter: true,
  //     // sorter: (a, b) => parseFloat(a.gpr || 0) - parseFloat(b.gpr || 0),
  //     render: (val) =>
  //       val === undefined || val === "" || val === "null"
  //         ? "-"
  //         : `${val?.toFixed(2)}%`,
  //   },
  //   {
  //     title: "Delta GCR %",
  //     dataIndex: "deltaGcr",
  //     align: "right",
  //     sorter: false,
  //     // sorter: (a, b) => parseFloat(a.gpr || 0) - parseFloat(b.gpr || 0),
  //     render: (val) =>
  //       val === undefined || val === "" || val === "null"
  //         ? "-"
  //         : `${val?.toFixed(2)}%`,
  //   },
  //   {
  //     title: "Delta SGCR %",
  //     dataIndex: "deltaSgcr",
  //     align: "right",
  //     sorter: false,
  //     // sorter: (a, b) => parseFloat(a.gpr || 0) - parseFloat(b.gpr || 0),
  //     render: (val) =>
  //       val === undefined || val === "" || val === "null"
  //         ? "-"
  //         : `${val?.toFixed(2)}%`,
  //   },
  //   {
  //     title: "Delta GPR %",
  //     dataIndex: "deltaGpr",
  //     align: "right",
  //     sorter: true,
  //     // sorter: (a, b) => parseFloat(a.gpr || 0) - parseFloat(b.gpr || 0),
  //     render: (val) =>
  //       val === undefined || val === "" || val === "null"
  //         ? "-"
  //         : `${val?.toFixed(2)}%`,
  //   },
  //   {
  //     title: "Trend Type",
  //     dataIndex: "trendType",
  //     align: "right",
  //     sorter: false,
  //     // sorter: (a, b) => parseFloat(a.gpr || 0) - parseFloat(b.gpr || 0),
  //     render: (val) =>
  //       val === undefined || val === "" || val === "null" ? "-" : val,
  //   },
  // ];

  // ── Chart data: aggregate daily by perf_date ─────────────────────────────
  // const dailyChartData = useMemo(() => {
  //   const map = {};
  //   tableData.forEach((r) => {
  //     const d = r.perf_date;
  //     if (!d) return;
  //     if (!map[d]) map[d] = { date: d, gcr: [], sgcr: [] };
  //     if (r.gcr  != null && !isNaN(r.gcr))  map[d].gcr.push(Number(r.gcr));
  //     if (r.sgcr != null && !isNaN(r.sgcr)) map[d].sgcr.push(Number(r.sgcr));
  //   });
  //   const avg = (arr) => arr.length ? parseFloat((arr.reduce((a,b)=>a+b,0)/arr.length).toFixed(2)) : null;
  //   return Object.values(map)
  //     .map((d) => ({ date: d.date, "Avg GCR %": avg(d.gcr), "Avg SGCR %": avg(d.sgcr) }))
  //     .sort((a, b) => new Date(a.date) - new Date(b.date));
  // }, [tableData]);

  // ── Chart data: aggregate monthly by month ────────────────────────────────
  // const monthlyChartData = useMemo(() => {
  //   const map = {};
  //   (monthlyTrends || []).forEach((r) => {
  //     const m = r.month;
  //     if (!m) return;
  //     if (!map[m]) map[m] = { month: m, gcr: [], sgcr: [], gpr: [] };
  //     if (r.gcr  != null && !isNaN(r.gcr))  map[m].gcr.push(Number(r.gcr));
  //     if (r.sgcr != null && !isNaN(r.sgcr)) map[m].sgcr.push(Number(r.sgcr));
  //     if (r.gpr  != null && !isNaN(r.gpr))  map[m].gpr.push(Number(r.gpr));
  //   });
  //   const avg = (arr) => arr.length ? parseFloat((arr.reduce((a,b)=>a+b,0)/arr.length).toFixed(2)) : null;
  //   return Object.values(map)
  //     .map((d) => ({ month: d.month, "Avg GCR %": avg(d.gcr), "Avg SGCR %": avg(d.sgcr), "Avg GPR %": avg(d.gpr) }))
  //     .sort((a, b) => a.month.localeCompare(b.month));
  // }, [monthlyTrends]);


  const columns = [
       
      {
        title: "Account Number",
        dataIndex: "accountId",
        align:"left",
        sorter: false,
        // sorter: (a, b) => String(a.accountId).localeCompare(String(b.accountId)),
        // filteredValue: [searchText],
        // onFilter: (value, record) => {
        //   return (
        //     String(record.accountName)
        //       .toLowerCase()
        //       .includes(value.toLowerCase()) ||
        //     String(record.email).toLowerCase().includes(value.toLowerCase()) ||
        //     String(record.accountId)
        //       .toLowerCase()
        //       .includes(value.toLowerCase()) ||
        //     String(record.phone).toLowerCase().includes(value.toLowerCase())
        //   );
        // },
      },
      {
        title: "Account Name",
        dataIndex: "accountName",
        sorter: false,
        // sorter: (a, b) =>
        //   String(a.accountName).localeCompare(String(b.accountName)),
        render: (text, record) => (
          <span
            className="cursor-pointer hover:underline hover:text-blue-800 transition"
            onClick={() => {
              const formattedAccountId = record.accountId
                ?.toString()
                .startsWith("0")
                ? record.accountId.toString().replace(/^0+/, "")
                : record.accountId;
  
              const params = new URLSearchParams({
                accountId: Number(formattedAccountId),
                accountName: record.accountName,
              }).toString();
  
              window.open(`/react-dashboard?${params}`, "_blank");
            }}
          >
            {text}
          </span>
        ),
      },
     
      
      { title: "Email", dataIndex: "email",
        sorter: false,
        // sorter: (a, b) => String(a.email).localeCompare(String(b.email)),
        render: (v) => ((v === null || v==="null" || v ==="" || v== undefined) ? '-' : v)
       },
      { title: "Phone", dataIndex: "phone", align: "left",
        render: (v) => ((v === null || v==="null" || v ==="" || v== undefined) ? '-' : v)
      },
      {
        title: "Date",
        dataIndex: "perfDate",
        sorter: false,
        // sorter: (a, b) => String(a.perf_date).localeCompare(String(b.perf_date)),
        render: (text, record) => (
        <span>{moment(text).format("MM-DD-YYYY")}</span>
      ),
      },
      {
        title: "GCR %",
        key: "gcr_trend",
        align: "center",
        sorter:false,
        // sorter: (a, b) => parseFloat(a.gcr || 0) - parseFloat(b.gcr || 0),
        render: (_, rec) => {
          const cur  = parseFloat(rec.gcr);
          const prev = parseFloat(rec.previousGcr);
          const diff = parseFloat(rec.deltaGcr);
          if (isNaN(cur)) return "-";
          const neutral = isNaN(diff) || Math.abs(diff) < 0.001;
          const up = !neutral && diff > 0;
          const icon = neutral
            ? <span className="text-gray-400">●</span>
            : up ? <ArrowUpOutlined /> : <ArrowDownOutlined />;
          const clr = neutral ? "text-gray-400" : up ? "text-green-600" : "text-red-500";
          const tip = <div style={{ lineHeight: 1.8 }}>
            <div>Current: {cur.toFixed(2)}%</div>
            <div>Previous: {isNaN(prev) ? "—" : prev.toFixed(2) + "%"}</div>
            <div>Diff: {isNaN(diff) ? "—" : (diff >= 0 ? "+" : "") + diff.toFixed(2)}</div>
          </div>;
          return (
            <Tooltip title={tip}>
              <div className="cursor-help">
                <div className="font-semibold">{cur.toFixed(2)}%</div>
                {!isNaN(diff) && (
                  <div className={`text-xs flex items-center justify-center gap-1 mt-0.5 ${clr}`}>
                    {icon}
                    <span>{diff >= 0 ? "+" : ""}{diff.toFixed(2)}</span>
                    <span className="text-gray-400">({isNaN(prev) ? "—" : prev.toFixed(2)})</span>
                  </div>
                )}
              </div>
            </Tooltip>
          );
        },
      },
      {
        title: "sGCR %",
        key: "sgcr_trend",
        align: "center",
        sorter:false,
        // sorter: (a, b) => parseFloat(a.sgcr || 0) - parseFloat(b.sgcr || 0),
        render: (_, rec) => {
          const cur  = parseFloat(rec.sgcr);
          const prev = parseFloat(rec.previousSgcr);
          const diff = parseFloat(rec.deltaSgcr);
          if (isNaN(cur)) return "-";
          const neutral = isNaN(diff) || Math.abs(diff) < 0.001;
          const up = !neutral && diff > 0;
          const icon = neutral
            ? <span className="text-gray-400">●</span>
            : up ? <ArrowUpOutlined /> : <ArrowDownOutlined />;
          const clr = neutral ? "text-gray-400" : up ? "text-green-600" : "text-red-500";
          const tip = <div style={{ lineHeight: 1.8 }}>
            <div>Current: {cur.toFixed(2)}%</div>
            <div>Previous: {isNaN(prev) ? "—" : prev.toFixed(2) + "%"}</div>
            <div>Diff: {isNaN(diff) ? "—" : (diff >= 0 ? "+" : "") + diff.toFixed(2)}</div>
          </div>;
          return (
            <Tooltip title={tip}>
              <div className="cursor-help">
                <div className="font-semibold">{cur.toFixed(2)}%</div>
                {!isNaN(diff) && (
                  <div className={`text-xs flex items-center justify-center gap-1 mt-0.5 ${clr}`}>
                    {icon}
                    <span>{diff >= 0 ? "+" : ""}{diff.toFixed(2)}</span>
                    <span className="text-gray-400">({isNaN(prev) ? "—" : prev.toFixed(2)})</span>
                  </div>
                )}
              </div>
            </Tooltip>
          );
        },
      },
    ];
  
    const columnsMonth = [
      {
        title: "Loc ID",
        dataIndex: "LocID",
        sorter: true,
        sorter: (a, b) => parseFloat(a.LocID || 0) - parseFloat(b.LocID || 0),
        render: (text, record) => (
          <span>
            {text}
          </span>
        ),
      },
      {
        title: "Account Number",
        dataIndex: "accountId",
        align:"right",
        sorter: true,
        sorter: (a, b) => String(a.accountId).localeCompare(String(b.accountId)),
        filteredValue: [searchTextMonth],
        onFilter: (value, record) => {
          return (
            String(record.accountName)
              .toLowerCase()
              .includes(value.toLowerCase()) ||
            String(record.email).toLowerCase().includes(value.toLowerCase()) ||
            String(record.accountId)
              .toLowerCase()
              .includes(value.toLowerCase()) ||
            String(record.phone).toLowerCase().includes(value.toLowerCase())
          );
        },
      },
      {
        title: "Account Name",
        dataIndex: "accountName",
        sorter: true,
        sorter: (a, b) =>
          String(a.accountName).localeCompare(String(b.accountName)),
        render: (text, record) => (
          <span
            className="cursor-pointer hover:underline hover:text-blue-800 transition"
            onClick={() => {
              const formattedAccountId = record.accountId
                ?.toString()
                .startsWith("0")
                ? record.accountId.toString().replace(/^0+/, "")
                : record.accountId;
  
              const params = new URLSearchParams({
                accountId: Number(formattedAccountId),
                accountName: record.accountName,
              }).toString();
  
              window.open(`/react-dashboard?${params}`, "_blank");
            }}
          >
            {text}
          </span>
        ),
      },
      
  
      { title: "Email", dataIndex: "email",
        sorter: true,
        sorter: (a, b) => String(a.email).localeCompare(String(b.email)),
        render: (v) => ((v === null || v==="null" || v ==="" || v== undefined) ? '-' : v)
       },
      { title: "Phone", dataIndex: "phone", align: "left",
        render: (v) => ((v === null || v==="null" || v ==="" || v== undefined) ? '-' : v)
      },
      {
        title: "Month",
        dataIndex: "month",
        sorter: true,
        sorter: (a, b) => String(a?.month).localeCompare(String(b?.month)),
        render: (month) => moment(month, "YYYY-MM").format("MM-YYYY"),
      },
      {
        title: "GCR %",
        key: "gcr_trend",
        align: "center",
        sorter: (a, b) => parseFloat(a.gcr || 0) - parseFloat(b.gcr || 0),
        render: (_, rec) => {
          const cur  = parseFloat(rec.gcr);
          const prev = parseFloat(rec.previousGcr);
          const diff = parseFloat(rec.deltaGcr);
          if (isNaN(cur)) return "-";
          const neutral = isNaN(diff) || Math.abs(diff) < 0.001;
          const up = !neutral && diff > 0;
          const icon = neutral
            ? <span className="text-gray-400">●</span>
            : up ? <ArrowUpOutlined /> : <ArrowDownOutlined />;
          const clr = neutral ? "text-gray-400" : up ? "text-green-600" : "text-red-500";
          const tip = <div style={{ lineHeight: 1.8 }}>
            <div>Current: {cur.toFixed(2)}%</div>
            <div>Previous: {isNaN(prev) ? "—" : prev.toFixed(2) + "%"}</div>
            <div>Diff: {isNaN(diff) ? "—" : (diff >= 0 ? "+" : "") + diff.toFixed(2)}</div>
          </div>;
          return (
            <Tooltip title={tip}>
              <div className="cursor-help">
                <div className="font-semibold">{cur.toFixed(2)}%</div>
                {!isNaN(diff) && (
                  <div className={`text-xs flex items-center justify-center gap-1 mt-0.5 ${clr}`}>
                    {icon}
                    <span>{diff >= 0 ? "+" : ""}{diff.toFixed(2)}</span>
                    <span className="text-gray-400">({isNaN(prev) ? "—" : prev.toFixed(2)})</span>
                  </div>
                )}
              </div>
            </Tooltip>
          );
        },
      },
      {
        title: "sGCR %",
        key: "sgcr_trend",
        align: "center",
        sorter: (a, b) => parseFloat(a.sgcr || 0) - parseFloat(b.sgcr || 0),
        render: (_, rec) => {
          const cur  = parseFloat(rec.sgcr);
          const prev = parseFloat(rec.previousSgcr);
          const diff = parseFloat(rec.deltaSgcr);
          if (isNaN(cur)) return "-";
          const neutral = isNaN(diff) || Math.abs(diff) < 0.001;
          const up = !neutral && diff > 0;
          const icon = neutral
            ? <span className="text-gray-400">●</span>
            : up ? <ArrowUpOutlined /> : <ArrowDownOutlined />;
          const clr = neutral ? "text-gray-400" : up ? "text-green-600" : "text-red-500";
          const tip = <div style={{ lineHeight: 1.8 }}>
            <div>Current: {cur.toFixed(2)}%</div>
            <div>Previous: {isNaN(prev) ? "—" : prev.toFixed(2) + "%"}</div>
            <div>Diff: {isNaN(diff) ? "—" : (diff >= 0 ? "+" : "") + diff.toFixed(2)}</div>
          </div>;
          return (
            <Tooltip title={tip}>
              <div className="cursor-help">
                <div className="font-semibold">{cur.toFixed(2)}%</div>
                {!isNaN(diff) && (
                  <div className={`text-xs flex items-center justify-center gap-1 mt-0.5 ${clr}`}>
                    {icon}
                    <span>{diff >= 0 ? "+" : ""}{diff.toFixed(2)}</span>
                    <span className="text-gray-400">({isNaN(prev) ? "—" : prev.toFixed(2)})</span>
                  </div>
                )}
              </div>
            </Tooltip>
          );
        },
      },
      {
        title: "GPR %",
        key: "gpr_trend",
        align: "center",
        sorter: (a, b) => parseFloat(a.gpr || 0) - parseFloat(b.gpr || 0),
        render: (_, rec) => {
          const cur  = parseFloat(rec.gpr);
          const prev = parseFloat(rec.previousGpr);
          const diff = parseFloat(rec.deltaGpr);
          if (isNaN(cur)) return "-";
          const neutral = isNaN(diff) || Math.abs(diff) < 0.001;
          const up = !neutral && diff > 0;
          const icon = neutral
            ? <span className="text-gray-400">●</span>
            : up ? <ArrowUpOutlined /> : <ArrowDownOutlined />;
          const clr = neutral ? "text-gray-400" : up ? "text-green-600" : "text-red-500";
          const tip = <div style={{ lineHeight: 1.8 }}>
            <div>Current: {cur.toFixed(2)}%</div>
            <div>Previous: {isNaN(prev) ? "—" : prev.toFixed(2) + "%"}</div>
            <div>Diff: {isNaN(diff) ? "—" : (diff >= 0 ? "+" : "") + diff.toFixed(2)}</div>
          </div>;
          return (
            <Tooltip title={tip}>
              <div className="cursor-help">
                <div className="font-semibold">{cur.toFixed(2)}%</div>
                {!isNaN(diff) && (
                  <div className={`text-xs flex items-center justify-center gap-1 mt-0.5 ${clr}`}>
                    {icon}
                    <span>{diff >= 0 ? "+" : ""}{diff.toFixed(2)}</span>
                    <span className="text-gray-400">({isNaN(prev) ? "—" : prev.toFixed(2)})</span>
                  </div>
                )}
              </div>
            </Tooltip>
          );
        },
      },
    ]
  const handleSearch = (val) => {
    setSearchText(val);
    console.log(val, "vallll");
    const filtered = tableData?.filter(
      (user) =>
        user?.accountName?.toLowerCase().includes(searchText.toLowerCase()) ||
        String(user?.accountId || "").includes(searchText.toLowerCase()) ||
        String(user?.email || "").includes(searchText.toLowerCase()),
    );
    setTableData(filtered);
  };

  const monthLbl = (value) => {
    const date = new Date(`${value}-01`);

    return date.toLocaleDateString("en-US", {
      month: "short",
      year: "2-digit",
    });
  };
  return (
    <div>
      {!embedded && <HeaderCompo initialColor="#000833" />}

      <div className={embedded ? "" : "p-6"}>
        <div className="flex flex-col md:flex-row justify-between my-4 gap-4 ">
          <h1 className="text-2xl font-bold">Monthly Trend</h1>
          <div className="flex flex-row sm:flex-row items-stretch sm:items-center gap-2 w-full lg:w-auto">
              <Input
                placeholder="Search Account No"
                suffix={<SearchOutlined />}
                value={searchAccount}
                onChange={(e) => setSearchAccount(e.target.value)}
                className="w-full sm:w-[280px]"
                style={{
                  border: "1px solid var(--Primary-Dark-Blue, #000833)",
                }}
              />
              <Button icon={<SearchOutlined />} onClick = {()=>getAllGraphsData(searchAccount)}>
                Search
              </Button>
            </div>
        </div>
        <Row gutter={[16, 16]} className="mb-8 mt-5">
          <Col xs={24} md={12}>
          <Card
              title={
                <div>
                  <div className="cardtitle mb-1">Monthly GCR / SGCR Trend</div>
                </div>
              }
              className="bg-white h-full CardShadow cardAni"
            >
              <Spin spinning={isLoadingGrpah}>
                <div className="w-full overflow-x-auto scrollbar-hide">
                  <div className="min-w-[590px] h-[350px]">
            <ResponsiveContainer width="100%" height="100%">
              <LineChart
                data={allGrphsData}
                margin={{ top: 5, right: 24, left: 0, bottom: 5 }}
              >
                <CartesianGrid strokeDasharray="3 3" vertical={false} />

                <XAxis
                  dataKey="month"
                  tick={{ fontSize: 11 }}
                  tickFormatter={(month) => {
                    const [year, monthNumber] = month.split("-");
                    return new Date(
                      year,
                      Number(monthNumber) - 1,
                    ).toLocaleDateString("en-US", {
                      month: "short",
                      year: "2-digit",
                    });
                  }}
                />

                <YAxis
                  tickFormatter={(value) => `${value}%`}
                  tick={{ fontSize: 11 }}
                  domain={[0, 100]}
                />

                <ChartTooltip
                  formatter={(value, name) =>
                    value !== null && value !== undefined
                      ? [`${Number(value).toFixed(2)}%`, name]
                      : ["-", name]
                  }
                  labelFormatter={(month) => {
                    const [year, monthNumber] = month.split("-");
                    return new Date(
                      year,
                      Number(monthNumber) - 1,
                    ).toLocaleDateString("en-US", {
                      month: "long",
                      year: "numeric",
                    });
                  }}
                />

                <Legend />

                <Line
                  type="monotone"
                  dataKey="gcrPercentage"
                  name="GCR"
                  stroke="#1f2a6d"
                  strokeWidth={2}
                  dot={{ r: 4 }}
                  activeDot={{ r: 6 }}
                />

                <Line
                  type="monotone"
                  dataKey="sgcrPercentage"
                  name="SGCR"
                  stroke="#e53935"
                  strokeWidth={2}
                  dot={{ r: 4 }}
                  activeDot={{ r: 6 }}
                />

                {/* <Line
                  type="monotone"
                  dataKey="gprPercentage"
                  name="GPR"
                  stroke="#2e7d32"
                  strokeWidth={2}
                  dot={{ r: 4 }}
                  activeDot={{ r: 6 }}
                /> */}
              </LineChart>
            </ResponsiveContainer>
            </div>
            </div>
        </Spin>
=          </Card>
        </Col>

        <Col xs={24} md={12}>
            <Card
              title={
                <div>
                  <div className="cardtitle mb-1">Total Rx</div>
                </div>
              }
              className="bg-white h-full CardShadow cardAni"
            >
              <Spin spinning={isLoadingGrpah}>
                <div className="w-full overflow-x-auto scrollbar-hide">
                  <div className="min-w-[590px] h-[350px]">
                    <ResponsiveContainer width="100%" height="100%">
                      <BarChart
                        data={allGrphsData}
                        barSize={30}
                        barGap={2}
                        barCategoryGap="10%"
                        margin={{
                          top: 10,
                          right: 20,
                          left: 10,
                          bottom: 20,
                        }}
                      >
                        <CartesianGrid strokeDasharray="3 3" vertical={false} />

                        <XAxis dataKey="month" tickFormatter={monthLbl} />

                        <YAxis
                          tickFormatter={(value) =>
                            `$${(value / 1000000).toFixed(1)}M`
                          }
                          domain={["auto", "auto"]}
                        />

                        <ChartTooltip
                          labelFormatter={monthLbl}
                          formatter={(value) =>
                            `$${Number(value).toLocaleString()}`
                          }
                        />
                        <Legend />

                        <Bar
                          dataKey="totalRx"
                          stackId="a"
                          fill="#2F80ED"
                          name="Total Rx"
                          radius={[0, 0, 0, 0]}
                        />

                        {/* <Bar
                          dataKey="brandRx"
                          stackId="a"
                          fill="#F16632"
                          name="Brand Rx"
                          radius={[4, 4, 0, 0]}
                        /> */}
                      </BarChart>
                    </ResponsiveContainer>
                  </div>
                </div>
              </Spin>
            </Card>
          </Col>
        </Row>

        <Row gutter={[16, 16]} className="mb-8 mt-5">
          {/* Generic Vs Brand Spend */}
          <Col xs={24} md={12}>
            <Card
              title={
                <div>
                  <div className="cardtitle mb-1">Generic Vs Brand Spend</div>
                </div>
              }
              className="bg-white h-full CardShadow cardAni"
            >
              <Spin spinning={isLoadingGrpah}>
                <div className="w-full overflow-x-auto scrollbar-hide">
                  <div className="min-w-[590px] h-[350px]">
                    <ResponsiveContainer width="100%" height="100%">
                      <BarChart
                        data={allGrphsData}
                        barSize={30}
                        barGap={2}
                        barCategoryGap="10%"
                        margin={{
                          top: 10,
                          right: 20,
                          left: 10,
                          bottom: 20,
                        }}
                      >
                        <CartesianGrid strokeDasharray="3 3" vertical={false} />

                        <XAxis dataKey="month" tickFormatter={monthLbl} />

                        <YAxis
                          tickFormatter={(value) =>
                            `$${(value / 1000000).toFixed(1)}M`
                          }
                        />

                        <ChartTooltip
                          labelFormatter={monthLbl}
                          formatter={(value) =>
                            `$${Number(value).toLocaleString()}`
                          }
                        />

                        <Legend />

                        <Bar
                          dataKey="genericRx"
                          stackId="a"
                          fill="#2F80ED"
                          name="Generic Rx"
                          radius={[0, 0, 0, 0]}
                        />

                        <Bar
                          dataKey="brandRx"
                          stackId="a"
                          fill="#F16632"
                          name="Brand Rx"
                          radius={[4, 4, 0, 0]}
                        />
                      </BarChart>
                    </ResponsiveContainer>
                  </div>
                </div>
              </Spin>
            </Card>
          </Col>

          {/* RTL2 Spend */}
          <Col xs={24} md={12}>
            <Card
              title={
                <div>
                  <div className="cardtitle mb-1">RTL2 Spend</div>
                </div>
              }
              className="bg-white h-full CardShadow cardAni"
            >
              <Spin spinning={isLoadingGrpah}>
                <div className="w-full overflow-x-auto scrollbar-hide">
                  <div className="min-w-[590px] h-[350px]">
                    <ResponsiveContainer width="100%" height="100%">
                      <BarChart
                        data={allGrphsData}
                        barSize={30}
                        margin={{
                          top: 10,
                          right: 20,
                          left: 10,
                          bottom: 20,
                        }}
                      >
                        <CartesianGrid strokeDasharray="3 3" vertical={false} />

                        <XAxis dataKey="month" tickFormatter={monthLbl} />

                        <YAxis
                          tickFormatter={(value) =>
                            `$${(value / 1000).toFixed(0)}K`
                          }
                        />

                        <ChartTooltip
                          labelFormatter={monthLbl}
                          formatter={(value) =>
                            `$${Number(value).toLocaleString()}`
                          }
                        />

                        <Legend />

                        <Bar
                          dataKey="rtl2Rx"
                          fill="#5141A5"
                          name="RTL2 Rx"
                          radius={[4, 4, 0, 0]}
                        />
                      </BarChart>
                    </ResponsiveContainer>
                  </div>
                </div>
              </Spin>
            </Card>
          </Col>

          <Col xs={24} md={12}>
            <Card
              title={
                <div>
                  <div className="cardtitle mb-1">
                    Specialty, NDC exclusions, FLU, BIOSIM, HIV
                  </div>
                </div>
              }
              className="bg-white h-full CardShadow cardAni"
            >
              <Spin spinning={isLoadingGrpah}>
                <div className="w-full overflow-x-auto scrollbar-hide">
                  <div className="min-w-[700px] h-[350px]">
                    <ResponsiveContainer width="100%" height="100%">
                      <BarChart
                        data={allGrphsData}
                        barSize={30}
                        margin={{
                          top: 10,
                          right: 20,
                          left: 10,
                          bottom: 20,
                        }}
                      >
                        <CartesianGrid strokeDasharray="3 3" vertical={false} />

                        <XAxis dataKey="month" tickFormatter={monthLbl} />

                        <YAxis
                          tickFormatter={(value) =>
                            `$${(value / 1000000).toFixed(1)}M`
                          }
                        />

                        <ChartTooltip
                          labelFormatter={monthLbl}
                          formatter={(value) =>
                            `$${Number(value).toLocaleString()}`
                          }
                        />

                        <Legend />

                        <Bar
                          dataKey="specialty"
                          stackId="a"
                          fill="#2F80ED"
                          name="Specialty"
                        />

                        <Bar
                          dataKey="ndcExclusions"
                          stackId="a"
                          fill="#F16632"
                          name="NDC exclusions"
                        />

                        <Bar
                          dataKey="flu"
                          stackId="a"
                          fill="#20A464"
                          name="FLU"
                        />

                        <Bar
                          dataKey="biosim"
                          stackId="a"
                          fill="#F4B942"
                          name="BIOSIM"
                        />

                        <Bar
                          dataKey="hivSum"
                          stackId="a"
                          fill="#E96B9A"
                          name="HIV"
                          radius={[4, 4, 0, 0]}
                        />
                      </BarChart>
                    </ResponsiveContainer>
                  </div>
                </div>
              </Spin>
            </Card>
          </Col>

          {/* Estimated Rebate */}
          <Col xs={24} md={12}>
            <Card
              title={
                <div>
                  <div className="cardtitle mb-1">Estimated rebate</div>
                </div>
              }
              className="bg-white h-full CardShadow cardAni"
            >
              <Spin spinning={isLoadingGrpah}>
                <div className="w-full overflow-x-auto scrollbar-hide">
                  <div className="min-w-[590px] h-[350px]">
                    <ResponsiveContainer width="100%" height="100%">
                      <BarChart
                        data={allGrphsData}
                        barSize={30}
                        margin={{
                          top: 10,
                          right: 20,
                          left: 10,
                          bottom: 20,
                        }}
                      >
                        <CartesianGrid strokeDasharray="3 3" vertical={false} />

                        <XAxis dataKey="month" tickFormatter={monthLbl} />

                        <YAxis
                          tickFormatter={(value) =>
                            `$${(value / 1000).toFixed(0)}K`
                          }
                        />

                        <ChartTooltip
                          labelFormatter={monthLbl}
                          formatter={(value) =>
                            `$${Number(value).toLocaleString()}`
                          }
                        />

                        <Legend />

                        <Bar
                          dataKey="estimatedRebate"
                          fill="#008A08"
                          name="Estimated rebate"
                          radius={[5, 5, 0, 0]}
                        />
                      </BarChart>
                    </ResponsiveContainer>
                  </div>
                </div>
              </Spin>
            </Card>
          </Col>

          {/* OnStop Vs RTL2 */}
          {/* <Col xs={24} md={12}>
            <Card
              title={
                <div>
                  <div className="cardtitle mb-1">OnStop % vs RTL2 %</div>
                </div>
              }
              className="bg-white h-full CardShadow cardAni"
            >
              <Spin spinning={isLoadingGrpah}>
                <div className="w-full overflow-x-auto scrollbar-hide">
                  <div className="min-w-[590px] h-[350px]">
                    <ResponsiveContainer width="100%" height="100%">
                      <LineChart
                        data={allGrphsData}
                        margin={{
                          top: 10,
                          right: 20,
                          left: 10,
                          bottom: 20,
                        }}
                      >
                        <CartesianGrid strokeDasharray="3 3" vertical={false} />

                        <XAxis dataKey="month" tickFormatter={monthLbl} />

                        <YAxis tickFormatter={(value) => `${value}%`} />

                        <ChartTooltip
                          labelFormatter={monthLbl}
                          formatter={(value) => `${value}%`}
                        />

                        <Legend />

                        <Line
                          type="monotone"
                          dataKey="onestopPct"
                          stroke="#20B486"
                          strokeWidth={2}
                          dot={{ r: 3 }}
                          name="OnStop %"
                        />

                        <Line
                          type="monotone"
                          dataKey="rtl2Pct"
                          stroke="#5141A5"
                          strokeWidth={2}
                          dot={{ r: 3 }}
                          name="RTL2 %"
                        />
                      </LineChart>
                    </ResponsiveContainer>
                  </div>
                </div>
              </Spin>
            </Card>
          </Col> */}
        </Row>

        <Row gutter={[16, 16]} className="mb-8 mt-5">
          <Col xs={24} md={24}>
            <Card
              title={
                <div>
                  <div className="cardtitle mb-1">GPR Trend</div>
                </div>
              }
              className="bg-white h-full CardShadow cardAni"
            >
              <Spin spinning={isLoadingGrpah}>
                <div className="w-full overflow-x-auto scrollbar-hide">
                  <div className="min-w-[590px] h-[350px]">
                    <ResponsiveContainer width="100%" height="100%">
                      <BarChart
                        data={allGrphsData}
                        barSize={30}
                        barGap={2}
                        barCategoryGap="10%"
                        margin={{
                          top: 10,
                          right: 20,
                          left: 10,
                          bottom: 20,
                        }}
                      >
                        <CartesianGrid strokeDasharray="3 3" vertical={false} />

                        <XAxis dataKey="month" tickFormatter={monthLbl} />

                        <YAxis
                  tickFormatter={(value) => `${value}%`}
                  tick={{ fontSize: 11 }}
                  domain={[0, 100]}
                />

                        <ChartTooltip
                          labelFormatter={monthLbl}
                          formatter={(value) =>
                            `$${Number(value).toLocaleString()}`
                          }
                        />

                        <Legend />

                        <Bar
                          dataKey="gprPercentage"
                          stackId="a"
                          fill="#2F80ED"
                          name="GPR"
                          radius={[0, 0, 0, 0]}
                        />

                        {/* <Bar
                          dataKey="brandRx"
                          stackId="a"
                          fill="#F16632"
                          name="Brand Rx"
                          radius={[4, 4, 0, 0]}
                        /> */}
                      </BarChart>
                    </ResponsiveContainer>
                  </div>
                </div>
              </Spin>
            </Card>
          </Col>
        </Row>

         <div className="p-6">
        <div className="flex justify-between mb-4">
          <h1 className="text-2xl font-bold">Monthly Trend REVERSAL (GCR/SGCR/GPR)</h1>
        </div>
        {/* {allGrphsData.length > 0 && ( */}
        
        {/* )} */}

        <div className="flex flex-col gap-4 mb-4 w-full">
          {/* Top Row – Dates + Filter */}
          <div className="flex flex-col lg:flex-row lg:items-center gap-4 justify-between w-full">
            <div className="flex flex-col sm:flex-row flex-wrap items-start sm:items-center gap-3 w-full lg:w-auto">
              <div className="flex gap-4">
                <div className="flex flex-row sm:flex-row items-start sm:items-center gap-2">
                  <span className="font-medium text-gray-600">From</span>
                  <DatePicker
                    picker="month"
                    value={fromDateMonth ? dayjs(fromDateMonth) : null}
                    format="MM-YYYY"
                    className="w-full sm:w-[220px]"
                    placeholder="Select Month"
                    onChange={(date) => {
                      if (date) {
                        // const jsDate = date.startOf("month").toDate(); // First day of selected month
                        // setFromDateMonth(jsDate);
                        setFromDateMonth(date.format("YYYY-MM-DD"));
                      }else{
                        setFromDateMonth("")
                      }
                    }}
                  />
                </div>

                <div className="flex flex-row sm:flex-row items-start sm:items-center gap-2">
                  <span className="font-medium text-gray-600">To</span>
                  <DatePicker
                    picker="month"
                    value={toDateMonth ? dayjs(toDateMonth) : null}
                    format="MM-YYYY"
                    className="w-full sm:w-[220px]"
                    placeholder="Select Month"
                    onChange={(date) => {
                      if (date) {
                        // const jsDate = date.startOf("month").toDate();
                        // setToDateMonth(jsDate);
                        setToDateMonth(date.format("YYYY-MM-DD"));
                      }else{
                        setToDateMonth("")
                      }
                    }}
                  />
                </div>
              </div>

              {/* <Button
                type="primary"
                className="w-full sm:w-auto px-6"
                icon={<FilterOutlined />}
                onClick={() => getMothlyTrendsData(fromDateMonth, toDateMonth)}
              >
                Filter
              </Button> */}
            </div>

            {/* Search Section */}
            <div className="flex flex-row sm:flex-row items-stretch sm:items-center gap-2 w-full lg:w-auto">
              <Input
                placeholder="Search..."
                suffix={<SearchOutlined />}
                value={searchTextMonth}
                onChange={(e) => setSearchMonth(e.target.value)}
                className="w-full sm:w-[280px]"
                style={{
                  border: "1px solid var(--Primary-Dark-Blue, #000833)",
                }}
              />
              <Button icon={<DownloadOutlined />} onClick={handleExportMonth}>
                Export
              </Button>
              {/* <Button className="w-[100px] sm:w-auto">Search</Button> */}
            </div>
          </div>
        </div>

        {/* {isCheckBoxChange && (
          <div className="flex justify-end mb-3">
            <Button type="primary" loading={loadingCheck} onClick={handleSave}>
              Save Changes
            </Button>
          </div>
        )} */}

        {/* Monthly GCR / SGCR / GPR Trend Chart */}
        {/* {monthlyChartData.length > 0 && (
          <Card className="mb-5 CardShadow" bodyStyle={{ padding: "16px 8px" }}>
            <div className="font-semibold text-gray-700 mb-3 px-2">Monthly GCR / SGCR / GPR Trend</div>
            <ResponsiveContainer width="100%" height={260}>
              <LineChart data={monthlyChartData} margin={{ top: 5, right: 24, left: 0, bottom: 5 }}>
                <CartesianGrid strokeDasharray="3 3" vertical={false} />
                <XAxis dataKey="month" tick={{ fontSize: 11 }} />
                <YAxis tickFormatter={(v) => `${v}%`} tick={{ fontSize: 11 }} domain={["auto", "auto"]} />
                <ChartTooltip formatter={(v) => `${v}%`} />
                <Legend />
                <Line type="monotone" dataKey="Avg GCR %"  stroke="#1f2a6d" strokeWidth={2} dot={{ r: 3 }} connectNulls />
                <Line type="monotone" dataKey="Avg SGCR %" stroke="#e53935" strokeWidth={2} dot={{ r: 3 }} connectNulls />
                <Line type="monotone" dataKey="Avg GPR %"  stroke="#2e7d32" strokeWidth={2} dot={{ r: 3 }} connectNulls />
              </LineChart>
            </ResponsiveContainer>
          </Card>
        )} */}

        <div className="max-h-[800px] overflow-y-auto">
          <Table
            columns={columnsMonth}
            dataSource={monthlyTrends}
            // pagination={false}
            pagination={{
              pageSize: paginationMonth,
              showSizeChanger: true,
              showTotal: (total) => `Total ${total} accounts`,
              onShowSizeChange: (current, size) => {
                setPaginationMonth(size);
              },
            }}
            // onChange={handleTableChange}
            loading={isLoadingMonth}
            scroll={{ x: "max-content" }}
            rowKey="trans_id"
            size="middle"
            className="custom-table user-tbl"
          />
        </div>
      </div>

        <div className="flex justify-between mb-4">
          <h1 className="text-2xl font-bold">
            DAILY TREND REVERSAL (GCR/ SGCR)
          </h1>
          <Button icon={<DownloadOutlined />} loading={dailyTrendExport} onClick={handleExport}>
            Export
          </Button>
        </div>
        <div className="flex flex-col gap-4 mb-4 w-full">
          {/* Top Row – Dates + Filter */}
          <div className="flex flex-col lg:flex-row lg:items-center gap-4 justify-between w-full">
            <div className="flex flex-col sm:flex-row flex-wrap items-start sm:items-center gap-3 w-full lg:w-auto">
              <div className="flex gap-4">
                <div className="flex flex-row sm:flex-row items-start sm:items-center gap-2">
                  <span className="font-medium text-gray-600">From</span>
                  <DatePicker
                    value={fromDate ? dayjs(fromDate) : null}
                    format="MM-DD-YYYY"
                    className="w-full sm:w-[220px]"
                    placeholder="Select Start Date"
                    onChange={(date) => {
                      if (date) {
                        // const jsDate = new Date(date.toDate());
                        // jsDate.setHours(0, 0, 0, 0);
                        // setFromDate(jsDate);
                        setFromDate(date.format("YYYY-MM-DD"));
                      }else{
                        setFromDate(null)
                      }
                    }}
                  />
                </div>

                <div className="flex flex-row sm:flex-row items-start sm:items-center gap-2">
                  <span className="font-medium text-gray-600">To</span>
                  <DatePicker
                    value={toDate ? dayjs(toDate) : null}
                    format="MM-DD-YYYY"
                    className="w-full sm:w-[220px]"
                    placeholder="Select End Date"
                    onChange={(date) => {
                      if (date) {
                        // const jsDate = new Date(date.toDate());
                        // jsDate.setHours(23, 59, 59, 999);
                        // setToDate(jsDate);
                        setToDate(date.format("YYYY-MM-DD"));
                      }else{
                        setToDate(null)
                      }
                    }}
                  />
                </div>
              </div>

              <Button
                type="primary"
                className="w-full sm:w-auto px-6"
                icon={<FilterOutlined />}
                onClick={() => getDailyTrendsData(fromDate, toDate)}
              >
                Filter
              </Button>
            </div>

            {/* Search Section */}
            <div className="flex flex-row sm:flex-row items-stretch sm:items-center gap-2 w-full lg:w-auto">
              <Input
                placeholder="Search..."
                suffix={<SearchOutlined />}
                value={searchText}
                onChange={(e) => setSearchText(e.target.value)}
                className="w-full sm:w-[280px]"
                style={{
                  border: "1px solid var(--Primary-Dark-Blue, #000833)",
                }}
              />
              {/* <Button className="w-[100px] sm:w-auto">Search</Button> */}
            </div>
          </div>
        </div>

        {isCheckBoxChange && (
          <div className="flex justify-end mb-3">
            <Button type="primary" loading={loadingCheck} onClick={handleSave}>
              Save Changes
            </Button>
          </div>
        )}

        {/* Daily GCR / SGCR Trend Chart */}
        {/* {tableData.length > 0 && (
          <Card className="mb-5 CardShadow" bodyStyle={{ padding: "16px 8px" }}>
            <div className="font-semibold text-gray-700 mb-3 px-2">Daily GCR / SGCR Trend</div>
            <ResponsiveContainer width="100%" height={260}>
              <LineChart data={tableData} margin={{ top: 5, right: 24, left: 0, bottom: 5 }}>
                <CartesianGrid strokeDasharray="3 3" vertical={false} />
                <XAxis dataKey="date" tick={{ fontSize: 11 }} />
                <YAxis tickFormatter={(v) => `${v}%`} tick={{ fontSize: 11 }} domain={["auto", "auto"]} />
                <ChartTooltip formatter={(v) => `${v}%`} />
                <Legend />
                <Line type="monotone" dataKey="Avg GCR %"  stroke="#1f2a6d" strokeWidth={2} dot={{ r: 3 }} connectNulls />
                <Line type="monotone" dataKey="Avg SGCR %" stroke="#e53935" strokeWidth={2} dot={{ r: 3 }} connectNulls />
              </LineChart>
            </ResponsiveContainer>
          </Card>
        )} */}

        {/* {tableData?.length > 0 && (
  <Card
    className="mb-5 CardShadow"
    bodyStyle={{ padding: "16px 8px" }}
  >
    <div className="font-semibold text-gray-700 mb-3 px-2">
      Daily GCR / SGCR / GPR Trend
    </div>

    <ResponsiveContainer width="100%" height={260}>
      <LineChart
        data={tableData}
        margin={{ top: 5, right: 24, left: 0, bottom: 5 }}
      >
        <CartesianGrid strokeDasharray="3 3" vertical={false} />

        <XAxis
          dataKey="perfDate"
          tick={{ fontSize: 11 }}
          tickFormatter={(date) =>
            new Date(date).toLocaleDateString("en-US", {
              month: "short",
              day: "numeric",
            })
          }
        />

        <YAxis
          tickFormatter={(value) => `${value}%`}
          tick={{ fontSize: 11 }}
          domain={[0, 100]}
        />

        <ChartTooltip
          formatter={(value, name) => [`${value}%`, name]}
          labelFormatter={(date) =>
            new Date(date).toLocaleDateString("en-US", {
              month: "short",
              day: "numeric",
              year: "numeric",
            })
          }
        />

        <Legend />

        <Line
          type="monotone"
          dataKey="gcr"
          name="GCR"
          stroke="#1f2a6d"
          strokeWidth={2}
          // dot={{ r: 4 }}
           dot={(props) => <CustomDot {...props} type="gcr" />}
          activeDot={{ r: 6 }}
          connectNulls
        />

        <Line
          type="monotone"
          dataKey="sgcr"
          name="SGCR"
          stroke="#e53935"
          strokeWidth={2}
          // dot={{ r: 4 }}
           dot={(props) => <CustomDot {...props} type="gcr" />}
          activeDot={{ r: 6 }}
          connectNulls
        />

        <Line
          type="monotone"
          dataKey="gpr"
          name="GPR"
          stroke="#2e7d32"
          strokeWidth={2}
          dot={{ r: 4 }}
          activeDot={{ r: 6 }}
          connectNulls
        />
      </LineChart>
    </ResponsiveContainer>
  </Card>
)} */}
        <div className="max-h-[800px] overflow-y-auto mb-10">
          <Table
            columns={columns}
            dataSource={tableData}
            // pagination={false}
            pagination={{
              current: pagination.current,
              pageSize: pagination.pageSize,
              total: pagination.total,
              showSizeChanger: true,
              showTotal: (total) => `Total ${total} accounts`,
              onChange: (page, pageSize) => {
                getDailyTrendsData(fromDate, toDate, page, pageSize);
              },
              onShowSizeChange: (current, size) => {
                getDailyTrendsData(fromDate, toDate, 1, size);
              },
            }}
            // onChange={handleTableChange}
            loading={isLoading}
            scroll={{ x: "max-content" }}
            rowKey="trans_id"
            size="middle"
            className="custom-table user-tbl "
          />
        </div>
      </div>

     
    </div>
  );
};

export default Trends;
